import {Box, Text, Heading, Center, Link} from '@chakra-ui/react';
import * as React from 'react';
import {SlideInBox} from './slide-in-box';

export const RefugeCharity: React.FC = () => {
  return (
    <Center bg="#FFF4FE" color="#DE2185">
      <Box maxW="880px" px="40px" py={{base: '60px', md: '110px'}}>
        <Box>
          <SlideInBox>
            <Heading fontSize={{base: '25px', md: '36px'}} zIndex={5}>
              Refuge Charity
            </Heading>
          </SlideInBox>
          <Text fontSize="18px" mt="10px" mb={6}>
            On any given day our services support thousands of women and their
            children, helping them to overcome the physical, emotional,
            financial and logistical impacts of abuse and rebuild their lives —
            free from fear. More than one in four women in England and Wales
            experiences domestic abuse at some point in their lifetime, and two
            women a week are killed by a current or former partner. You can find
            out more about Refuge’s work on their website{' '}
            <Link href="https://www.refuge.org.uk">www.refuge.org.uk</Link>.
          </Text>
          <Text fontSize="18px">
            Refuge’s National Domestic Abuse Helpline 0808 2000 247, is
            available 24 hours a day 7 days a week for free, confidential
            specialist support.
          </Text>
        </Box>
      </Box>
    </Center>
  );
};
